import {LANGUAGES,normalizeLanguage} from './languages';
const marker='sdkLang';
export function supportEntryLanguage(search){
 try{const value=new URLSearchParams(search||'').get(marker);
  return LANGUAGES.some(x=>x.code===value)?value:null;
 }catch(_){return null;}
}
export function supportUrl(value,language){
 // Preserve all existing support context and its destination. Only add a UI locale.
 if(typeof value!=='string'||!/^\/game-support\/(?:[?#]|$)/.test(value))return value;
 const url=new URL(value,'https://sdk-local.invalid');
 url.searchParams.set(marker,normalizeLanguage(language));
 return url.pathname+url.search+url.hash;
}
